import React from 'react';
import { useGyerekek } from '../GyerekekContext';

// Ezt a komponenst EGYSZER, globálisan kell beilleszteni az App.js-be (pl. a
// Navbar mellé), hogy bárhol az alkalmazásban — akár egy lecke/küldetés
// KÖZEPÉN is — azonnal felugorjon, amint a GyerekekContext új jelvényt
// észlel (lásd: haladasMentese a GyerekekContext.jsx-ben).
function JelvenyAblak() {
  const { ujJelveny, jelvenyBezaras } = useGyerekek();
  if (!ujJelveny) return null;
  const { jelveny } = ujJelveny;

  return (
    <div onClick={jelvenyBezaras} style={{
      position: 'fixed', inset: 0, background: 'rgba(26,26,46,0.6)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5000, padding: '1.5rem',
    }}>
      <style>{`
        @keyframes jelvenyFelugrik { 0% { transform: scale(0.7); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
        @keyframes jelvenyPulzal { 0%,100% { transform: scale(1); } 50% { transform: scale(1.1); } }
      `}</style>
      <div onClick={e => e.stopPropagation()} style={{
        background: 'white', borderRadius: '28px', padding: '2.5rem 2rem', maxWidth: '360px', width: '100%',
        textAlign: 'center', boxShadow: '0 24px 64px rgba(0,0,0,0.3)', position: 'relative',
        animation: 'jelvenyFelugrik 0.4s cubic-bezier(0.34,1.56,0.64,1)', fontFamily: "'Nunito', sans-serif",
      }}>
        <button onClick={jelvenyBezaras} style={{
          position: 'absolute', top: '14px', right: '14px', width: '32px', height: '32px', borderRadius: '50%',
          border: 'none', background: '#f0f0f0', fontSize: '16px', cursor: 'pointer', color: '#666',
        }}>✕</button>
        <div style={{fontSize: '18px', fontWeight: 800, color: '#f9ab00', marginBottom: '0.5rem', letterSpacing: '1px', textTransform: 'uppercase'}}>
          🎉 Új jelvény!
        </div>
        <div style={{fontSize: '72px', margin: '0.5rem 0', animation: 'jelvenyPulzal 1.5s ease-in-out infinite'}}>
          {jelveny.ikon}
        </div>
        <div style={{fontSize: '22px', fontWeight: 900, color: '#1a1a2e', marginBottom: '6px'}}>{jelveny.nev}</div>
        <div style={{fontSize: '14px', color: '#888', marginBottom: '1.75rem'}}>{jelveny.leiras}</div>
        <button onClick={jelvenyBezaras} style={{
          padding: '12px 32px', borderRadius: '50px', border: 'none', fontSize: '15px', fontWeight: 800,
          color: 'white', cursor: 'pointer', background: 'linear-gradient(135deg, #f9ab00, #ff6d00)',
          boxShadow: '0 6px 20px rgba(249,171,0,0.35)',
        }}>
          Szuper! 🚀
        </button>
      </div>
    </div>
  );
}

export default JelvenyAblak;